import React, { PropTypes } from 'react';
import ZoneItem from './ZoneItem';

const ZoneList = ({ intervention, zones, disabled = false }) => {
  if (zones.length) {
    return (
      <div>
        {zones.map(z => (
          <ZoneItem
            key={z.id}
            intervention={intervention}
            zone={z}
            disabled={disabled}
          />
        ))}
      </div>
    );
  }

  return <div className="ui message">Aucune zone associée à ce client</div>;
};

ZoneList.propTypes = {
  intervention: PropTypes.string.isRequired,
  zones: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
};

export default ZoneList;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/components/ZoneList.js